<template>
  <div>
    <div class="checkout mb-4 mt-4">
      <div class="container">
        <div class="row pb-4">
          <div class="col-lg-12">
            <h5 class="checkout-title text-center mb-4" style="font-size: 2rem">
              Recupera la password del tuo account
            </h5>
            <!-- End .checkout-title -->

            <div class="card border">
              <div class="m-4" v-if="successMessage">
                <AlertComponent
                  :message="successMessage"
                  :alert-type="'success'"
                />
              </div>
              <div class="m-4" v-if="error">
                <AlertComponent :message="error" :alert-type="'danger'" />
              </div>

              <form @submit.prevent="reset_password">
                <div class="card-body pl-5 pr-5">
                  <div>
                    <label for="email" class="text-center mb-1"
                      >E-Mail Address</label
                    >

                    <input
                      id="email"
                      type="email"
                      class="form-control mb-2"
                      name="email"
                      required
                      autocomplete="email"
                      placeholder="Inserisci la tua email"
                      v-model="form.email"
                      autofocus
                    />
                  </div>
                  <div class="alert alert-danger" v-if="errors.email">
                    {{ errors.email[0] }}
                  </div>
                </div>

                <div class="card-footer">
                  <div class="form-group row mb-1 mt-1">
                    <div class="col-md-6 offset-md-4">
                      <button type="submit" class="btn btn-primary">
                        INVIA IL LINK PER IL RESET DELLA PASSWORD
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AlertComponent from "@/components/AlertComponent.vue";
import http from "@/services/http.js";
export default {
  name: "RequestResetPassword",
  components: { AlertComponent },
  /*setup() {
    const router = 
  },*/
  data() {
    return {
      form: {
        email: "",
      },
      errors: [],
      error: "",
      user: "",
      successMessage: "",
    };
  },
  mounted() {},
  methods: {
    async reset_password() {
      this.successMessage = "";
      this.error = "";
      await http.post("/forgot-password", this.form).then((response) => {
        if (response.data.status) {
          this.form.email = "";
          this.successMessage = response.data.message;
        } else {
          this.error = response.data.message;
        }
      });
    },
  },
};
</script>